import React, { Component } from 'react';

import '../BarCodes.sass'

class ImportantModal extends Component {
    render() {
        const { all, updated, duplicate, errorSeatsCount, errorSeats, emptyBarcodesCount } = this.props;

        return (
            <div>
                <strong>It's important!</strong>
                <p>Check any ticket from this list before the event!</p>
                <div className="success-content">
                    <p>Success!</p>
                    <div className="results">
                        <p>All tickets in file: <span>{all}</span></p>
                        <p>Dublicated tickets: <span>{duplicate}</span></p>
                        <p>Updated tickets: <span>{updated}</span></p>
                        <p>Tickets with empty barcode: <span>{emptyBarcodesCount}</span></p>
                        <p>Tickets with wrong seats: <span>{errorSeatsCount}</span></p>
                        {errorSeats.length > 0 && (
                          <div className="results__wrong-seats">
                            <span>Wrong seats:</span>
                            <div>
                            {errorSeats.map((seat) => (
                              <p key={seat}>{seat}</p>
                            ))}
                            </div>
                          </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default ImportantModal;
